"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateMove = validateMove;
exports.applyValidatedMove = applyValidatedMove;
exports.isValidMoves = isValidMoves;
const board_1 = require("../board");
const Model_1 = require("../Model");
const players_1 = require("../players");
const lodash_1 = require("lodash");
function validateMove(state, move) {
    if ((0, board_1.countAtPoint)(state.board, state.turn, move.from) === 0) {
        throw new Error(`Invalid move player ${state.turn} no checkers at point ${move.from}`);
    }
    if (move.from <= Model_1.OFF_POINT) {
        throw new Error('Cannot move from off point');
    }
    if ((0, board_1.isReadyToBearOff)(state.board, state.turn)) {
        // all checkers are home
        const realTo = move.from - move.step;
        if (realTo === Model_1.OFF_POINT) {
            // remove exact dice
            return;
        }
        if (realTo < Model_1.OFF_POINT) {
            // not exact dice - make sure there are no higher points
            const playerPoints = (0, board_1.getPointsWithAtLeast)(state.board, state.turn, 1);
            const maxPoint = Math.max(...playerPoints);
            if (maxPoint > move.from) {
                throw new Error(`Cannot bear off from point (${move.from}) when a higher point (${maxPoint}) is available`);
            }
        }
    }
    else {
        // not all checkers are home
        if (move.to <= Model_1.OFF_POINT) {
            throw new Error('Not all checkers are home - cannot move to off point');
        }
        // from > OFF_POINT to > OFF_POINT
        if ((0, board_1.isOnBar)(state.board, state.turn) && move.from !== Model_1.BAR_POINT) {
            // can only move from bar
            throw new Error('Player has checkers on bar - must recover first');
        }
    }
    if ((0, board_1.isOccupied)(state.board, (0, players_1.opponent)(state.turn), (0, board_1.opponentPoint)(move.to))) {
        throw new Error('Cannot move to occupied point');
    }
}
function applyValidatedMove(state, move) {
    validateMove(state, move);
    return Object.assign(Object.assign({}, state), { board: (0, board_1.withMove)(state.board, state.turn, move) });
}
function isValidMoves(state, moves) {
    try {
        moves.reduce((s, move) => applyValidatedMove(s, move), (0, lodash_1.cloneDeep)(state));
        return true;
    }
    catch (_a) {
        return false;
    }
}
